import { Box, Typography } from '@mui/material';
import React from 'react';

const DayCell = ({
  date,
  availableCount = 0,
  reservedCount = 0,
  barPosition = null, // "start" | "middle" | "end" | null
  isOutsideMonth = false,
  isToday = false,
  isSelected = false,
  onClick,
}) => {
  // Päivän numero
  const pvmNro = date.getDate();

  return (
    <Box
      onClick={onClick}
      sx={{
        p: 0.5,
        borderRadius: 1,
        bgcolor: isSelected ? 'primary.light' : isToday ? 'primary.50' : 'background.paper',
        opacity: isOutsideMonth ? 0.4 : 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        border: '1px solid',
        borderColor: 'divider',
        cursor: 'pointer',
        overflow: 'hidden',
        width: '100%',
        flexGrow: 1,
      }}
    >
      {/* Pvm */}
      <Typography
        variant="body2"
        fontWeight={isToday ? 700 : 500}
        sx={{ color: isToday ? 'primary.main' : 'text.primary' }}
      >
        {pvmNro}
      </Typography>

      {/* Varaus"palkki" */}
      <Box sx={{ height: 4, width: '100%', mt: 0.5, minHeight: 4, flexShrink: 0 }}>
        {barPosition && (
          <Box
            sx={{
              height: '100%',
              bgcolor: 'primary.main',
              borderRadius:
                barPosition === 'start'
                  ? '4px 0 0 4px'
                  : barPosition === 'end'
                    ? '0 4px 4px 0'
                    : '0',
            }}
          />
        )}
      </Box>

      {/* Saatavuus-pallurat */}
      {
        (availableCount + reservedCount > 10
          ? (
              <Typography variant="caption" sx={{ mt: 0.3, color: 'text.secondary' }}>
                {reservedCount}
                /
                {availableCount + reservedCount}
              </Typography>
            )
          : (
              <Box display="flex" gap={0.3} flexWrap="wrap" sx={{ minHeight: 10, mt: 'auto' }}>
                {[...Array(reservedCount)].map((_, i) => (
                  <Box
                    key={`r${i}`}
                    sx={{
                      width: 6,
                      height: 6,
                      borderRadius: '50%',
                      bgcolor: 'error.main',
                    }}
                  />
                ))}

                {[...Array(availableCount)].map((_, i) => (
                  <Box
                    key={`a${i}`}
                    sx={{
                      width: 4,
                      height: 4,
                      borderRadius: '50%',
                      border: '1px solid',
                      borderColor: 'success.main',
                    }}
                  />
                ))}
              </Box>
            ))
      }
    </Box>
  );
};

export default DayCell;
